import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { Link as RouterLink } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import ConditionalPurpleLinearProgress from "../../../common/components/ConditionalLinearProgress"
import SegmentTracker from "../../../common/tracking"
import DialogHeader from "../components/DialogHeader"

export default function ConfirmAddLeadsToCandidatesDialog({
  open,
  onClose,
  selectedLeadIDS,
  apiEndpoint = "/crm/api/agents/add-to-candidates/",
  requestBodyKey = "agent_ids",
  trackingEventName = "MLS leads imported",
}) {
  const [isYessing, setIsYessing] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleYesButtonClicked() {
    setIsYessing(true)
    axios
      .post(apiEndpoint, {
        [requestBodyKey]: selectedLeadIDS,
      })
      .then(() => {
        onClose(true)
        SegmentTracker.track(trackingEventName, {
          Count: selectedLeadIDS.length,
        })
      })
      .finally(() => setIsYessing(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader
        title={`Add ${selectedLeadIDS.length} Leads To Candidates`}
        onClose={handleSoftClose}
      />
      <ConditionalPurpleLinearProgress visible={isYessing} />
      <DialogContent>
        <Column>
          <Typography variant="body1">
            This will add{" "}
            <strong>{selectedLeadIDS.length.toLocaleString()}</strong> leads to
            your{" "}
            <Link component={RouterLink} to="/candidates">
              Candidates
            </Link>{" "}
            page. <strong>Are you sure?</strong>
          </Typography>
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          No
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isYessing}
          onClick={handleYesButtonClicked}
        >
          Yes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
